import React from 'react';
import { withRouter } from 'react-router-dom';
import { auth } from '../../../Api';
import { overdueText, overdueClass, seesOverdueBanner } from '../../../utils/overdue';
import './suspension.scss';

// On page changes, ask the server again at most this often (coming back to the browser tab always asks)
const RECHECK_MS = 60000;

/**
 * The overdue banner at the top of every page for a company admin and its district managers (laravel billing/notice,
 * App\Overdue): an invoice past its due date and the date the service stops, with Pay now for the company admin; or,
 * once suspended for non-payment, which invoice and that it is reinstated once paid (the suspended company admin keeps the
 * Account > Billing tab, see suspension-banner.js). Mobiliis colours, red from the 2nd reminder's day. District
 * managers see a short version without amounts. Rendered by layouts/landingLayout.js.
 */
class OverdueBanner extends React.Component {
	constructor(props) {
		super(props);
		this.state = { notice: null };
		this.checkedAt = 0;
		this.onVisible = this.onVisible.bind(this);
	}

	componentDidMount() {
		this.unlisten = this.props.history.listen(() => this.check(false));
		document.addEventListener('visibilitychange', this.onVisible);
		this.check(true);
	}

	componentWillUnmount() {
		if (this.unlisten) {
			this.unlisten();
		}
		document.removeEventListener('visibilitychange', this.onVisible);
	}

	// Back on this browser tab (after paying in the tab Pay now opened, say): at once
	onVisible() {
		if (document.visibilityState === 'visible') {
			this.check(true);
		}
	}

	level() {
		try {
			return localStorage.getItem('admin_level');
		} catch (e) {
			return null;
		}
	}

	check(now) {
		if (!seesOverdueBanner(this.level()) || (!now && Date.now() - this.checkedAt < RECHECK_MS)) {
			return;
		}
		this.checkedAt = Date.now();
		auth.getBillingNotice({})
			.then((res) => {
				if (res && res.data && res.data.code == 200) {
					this.setState({ notice: res.data.notice || null });
				}
			})
			.catch(() => {});
	}

	pay() {
		window.open(this.state.notice.pay_url, '_blank', 'noopener');
		// Coming back after paying: ask again
		this.checkedAt = 0;
	}

	render() {
		const { notice } = this.state;
		const level = this.level();
		if (!notice || !seesOverdueBanner(level)) {
			return null;
		}
		return (
			<div className={overdueClass(notice) + ' overdue-banner d-flex flex-wrap align-items-center justify-content-between'} role="status">
				<span className="mr-2">
					<i className="mdi mdi-information-outline mr-10"></i>
					{overdueText(notice, level)}
				</span>
				{level === 'c' && notice.pay_url && (
					<button type="button" className="btn btn-sm btn-primary" onClick={() => this.pay()}>Pay now</button>
				)}
			</div>
		);
	}
}

export default withRouter(OverdueBanner);
